import { render, staticRenderFns } from "./AffiliationDocumentList.vue?vue&type=template&id=0c807b52&scoped=true"
import script from "./AffiliationDocumentList.vue?vue&type=script&lang=js"
export * from "./AffiliationDocumentList.vue?vue&type=script&lang=js"
import style0 from "./AffiliationDocumentList.vue?vue&type=style&index=0&id=0c807b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c807b52",
  null
  
)

export default component.exports